import { useEffect, useMemo } from 'react';
import { StepEvents } from '@bingads-webui-campaign-react/step-wizard-machine';
import { useNavigationConfirmationPrompt } from './use-navigation-confirmation-prompt';
import { useWindowConfirm } from './use-window-confirm';

const EXIT_WITHOUT_SAVING_MESSAGE_KEY = _TL_('Your latest changes have not been saved. Do you want to continue without saving changes?');

export const useExitWithoutSavingConfirmation = (needsConfirmation, stepService, i18n, confirmationMessage = undefined) => {
  // Browser and router navigation cancelation must be synchronous, so cannot be handled by wizard-state-machine
  // because wizard-state-machine doesn't have enough information on whether an individual step can
  // navigate away or not, and would need to delegate this to the step-state-machine.
  // Wizard's navigation button based existing/canceling can be asynchronous and, again, will be
  // delegated to the current step as the step has necessary information.
  const exitConfirmationMessage = useMemo(() => confirmationMessage || i18n.getString(EXIT_WITHOUT_SAVING_MESSAGE_KEY), [i18n, confirmationMessage]);
  const navigationConfirmationPrompt = useNavigationConfirmationPrompt(needsConfirmation, exitConfirmationMessage);
  const confirmCancel = useWindowConfirm(exitConfirmationMessage);
  useEffect(() => {
    stepService.send({ type: StepEvents.OVERRIDE_ACTIONS, data: { confirmCancel } });
  }, [stepService, confirmCancel]);

  return [navigationConfirmationPrompt];
};
